import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import PageTitle from '@/components/v2/PageTitle.vue';
import ShippingForm from '@/components/v2/ShippingForm.vue';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import ShippingMethodCreate from '@/plugins/graphql/mutations/v2/shipping-method-create.gql';
import ShippingMethods from '@/plugins/graphql/queries/v2/shipping-methods.gql';
import { successfulCreate } from '@/helpers/mixins/LocalizationHelper';
import { Mutation } from 'vuex-class';
import AppDetailsMixin from '@/helpers/vue_mixins/v2/ecommerce/AppDetailsMixin';
import UpdateAppAllowAdvanceOrder from '@/plugins/graphql/mutations/v2/update-app-allow-advance-order.gql';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
let ShippingMethodsCreate = class ShippingMethodsCreate extends mixins(AlertMixin, RouterParamsAppMixin, AppDetailsMixin, CleverTapEventsMixin) {
    goToShippingsPage() {
        this.$router.push({ name: 'ecommerce-shipping' });
    }
    async onSubmit(form) {
        this.mutationRequestOnFlight();
        await this.create(form)
            .then(() => {
            const msg = successfulCreate('Shipping');
            this.successNotification(msg);
            this.shippingManagerAction('SUBMIT CREATE');
            this.goToShippingsPage();
        })
            .catch((e) => {
            this.errorNotification(e.message);
        })
            .finally(() => {
            this.requestDone();
        });
    }
    async create(form) {
        const appUuid = this.appUUID;
        this.$apollo.mutate({
            mutation: ShippingMethodCreate,
            variables: {
                input: {
                    name: form.name,
                    description: form.description,
                    price: form.fee,
                    customerInitiated: form.customerInitiated || false,
                    appUuid,
                },
            },
            update(cache, { data }) {
                const queryOptions = {
                    query: ShippingMethods,
                    variables: {
                        appUuid,
                    },
                };
                const { fetchAllShippingMethod } = cache.readQuery({
                    ...queryOptions,
                });
                if (!fetchAllShippingMethod) {
                    return;
                }
                const cachedShippingMethods = {
                    ...fetchAllShippingMethod,
                };
                cachedShippingMethods.edges.unshift({
                    node: data.shippingMethodAdd.shippingMethod,
                    __typename: 'ShippingMethodEdges',
                });
                cache.writeQuery({
                    ...queryOptions,
                    data: {
                        fetchAllShippingMethod: cachedShippingMethods,
                    },
                });
            },
        });
    }
    updateAllowAdvanceOrder(allowAdvanceOrder) {
        this.$apollo.mutate({
            mutation: UpdateAppAllowAdvanceOrder,
            variables: {
                input: {
                    appUuid: this.appUUID,
                    allowAdvanceOrder,
                },
            },
        });
    }
};
__decorate([
    Mutation('requestOnFlight')
], ShippingMethodsCreate.prototype, "mutationRequestOnFlight", void 0);
__decorate([
    Mutation('requestDone')
], ShippingMethodsCreate.prototype, "requestDone", void 0);
ShippingMethodsCreate = __decorate([
    Component({
        components: {
            PageTitle,
            ShippingForm,
            AppDetailsMixin,
        },
    })
], ShippingMethodsCreate);
export default ShippingMethodsCreate;
